import { render } from "./ModalSession.vue?vue&type=template&id=3c0b8f3b"
import script from "./ModalSession.vue?vue&type=script&lang=js"
export * from "./ModalSession.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__